import React, { Component } from "react";
import { DropdownButton,ButtonGroup,dropdownItem,Dropdown } from "react-bootstrap";
import ButtonIcon from "../../button"
import  './header-left-filter.component.css'
export class HeaderLeftFilter extends Component {
  
    render() {
        const {dropdownItem}=this.props;
        var today = new Date();
        return(
            <div className="header-left-filter-container">
                <DropdownButton
                as={ButtonGroup}                           
                title="Select"
                id="bg-vertical-dropdown-2"
                className="subscription-price-btn"
                >
                    {dropdownItem!==undefined ? dropdownItem.map((item,id)=>
                        <Dropdown.Item eventKey={id} key={id}><img src={item.ListImg} alt="img" className="image-list"/> {item.ListName}</Dropdown.Item>
                    ): ""}                      
                </DropdownButton>
                <div className="header-filter-button-container">
                    <ButtonIcon onClick={()=>alert("click")} iconLeft="download" iconSize="17px" customClassName="header-filter-button" labelName="Export Report"/>
                </div>
                <div className="header-filter-button-container">
                    <ButtonIcon onClick={()=>alert("click")} iconLeft="file-plus" iconSize="17px" customClassName="header-filter-button" labelName="Create Invoice"/>
                </div>
                <div className="min-calendar">
                    <span>{today.getDate()}</span>
                </div>
            </div>
        )
    }
}